import { gql } from "@apollo/client";
import { alpha } from "@mui/material";
import { COLOR_BLACK, COLOR_BLACK_LIGHTER, COLOR_WHITE_LIGHTER } from "helpers/colors";
import useData from "helpers/useData";
import Splash from "molecules/Splash";
import Subnav, { SubnavDropdown, SubnavDropdownItem, SubnavToggleLabel } from "molecules/Subnav";
import React from "react";

export default function PersonPagesHeader({ personId, tab }) {
  const [data] = useData(
    gql`
      query PersonPagesHeader($personId: ID!) {
        person(id: $personId) {
          id
          fullNameWithAnonymisation
          canOnsenPersonPageSettings
          org {
            id
            name
          }
        }
        currentUser {
          id
          people {
            id
            fullName
            org {
              id
              name
            }
          }
          supportingPeople {
            id
            fullNameWithAnonymisation
            org {
              id
              name
            }
          }
        }
      }
    `,
    { personId },
  );

  // Users see their own real name; supported and other people stay masked.
  const ownPeople = (data?.currentUser?.people || []).map((p) => ({ ...p, name: p.fullName }));
  const supportingPeople = (data?.currentUser?.supportingPeople || []).map((p) => ({
    ...p,
    name: p.fullNameWithAnonymisation,
  }));
  const personName = ownPeople.find((p) => p.id === personId)?.name || data?.person?.fullNameWithAnonymisation;

  return (
    <>
      <Splash
        color={COLOR_BLACK_LIGHTER}
        title={personName}
        descriptionHeader="Organisation"
        descriptionValue={data?.person?.org?.name}
      />
      <div
        style={{
          backgroundColor: COLOR_WHITE_LIGHTER,
          borderBottom: `1px solid ${alpha(COLOR_BLACK, 0.1)}`,
        }}
      >
        <Subnav wrap={false}>
          <SubnavDropdown text={personName}>
            {[...ownPeople, ...supportingPeople].map((person) => (
              <SubnavDropdownItem
                key={person.id}
                text={person.name}
                description={person.org.name}
                selected={person.id === personId}
                href={`/person/${person.id}`}
              >
                {person.name}
              </SubnavDropdownItem>
            ))}
          </SubnavDropdown>
          <SubnavToggleLabel text="Profile" checked={tab === "profile"} href={`/person/${personId}`} />
          {data?.person?.canOnsenPersonPageSettings && (
            <SubnavToggleLabel text="Settings" checked={tab === "settings"} href={`/person/${personId}/settings`} />
          )}
        </Subnav>
      </div>
    </>
  );
}
